import { useMemo } from "react";
import { initializeApolloClient } from "./initializeApolloClient.js";
function useApolloClient(initialState, countryCode, pageKey) {
    const store = useMemo(()=>initializeApolloClient({
            initialState,
            countryCode,
            pageKey
        }), [
        countryCode,
        initialState,
        pageKey
    ]);
    return store;
}
export { useApolloClient };
